var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('base-container',{class:["cube-checkbox-modal-page"]},[_c('checkbox-modal-default',{class:["demo-item"]}),_c('checkbox-modal-option-conf',{class:["demo-item"]}),_c('checkbox-modal-cancel-btn',{class:["demo-item"]}),_c('checkbox-modal-slots',{class:["demo-item"]})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }